<template>
  <div :class="['one-col-wrapper']">
    <div class="one-col-inner">
      <div class="one-col-left">
        <div :class="['one-col-title']">{{ title }}</div>
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OneColumnWrapper",
  props: {
    title: {
      type: String,
    }
  },
};
</script>

<style lang="scss">
.one-col-wrapper {
  width: 100%;
  margin-bottom: 1rem;

  .one-col-inner {
    display: flex;
    justify-content: space-between;
    > div {
      width: calc(50% - 1rem);
      flex: 0 0 calc(50% - 1rem);
    }
    .base-dropdown {
      width: 100%;
      box-sizing: border-box;
      height: 3.6rem;
      .dropdown-button {
        height: 100%;
        box-sizing: border-box;
        align-items:center;
      }
    }
  }

  .one-col-title {
    color: $blueDark;
    font-weight: bold;
    text-align: left;
    margin-bottom: 0.5rem;
  }
}
</style>
